import React from 'react';
import {compose, mapProps} from 'recompose';
import _ from 'lodash';

// import RestrictAccess, { Role, setupAccess } from '../common/access_control';
import gql from 'graphql-tag';
import {graphql} from 'react-apollo';
import {renderForError, renderWhileLoading} from 'App/util/recompose/graphql';
import {Card, CardBody, CardHeader} from 'reactstrap';
import GenderChart from './GenderChart';

// @setupAccess([Role.superAdmin])
@compose(
  graphql(gql`
  query {
    generals_genders_distributions {
      count
      gender
    }
  }`,
    {
      name: 'general_gender'
    }),
  graphql(gql`
  query {
    genders_distributions(order:{column:"name", direction: asc}) {
      count
      gender
      name
    }
  }`,
    {
      name: 'centre_gender'
    }),
  mapProps(
    (ownerProps) => ({
      ...ownerProps,
      data: {
        ...ownerProps.centre_gender,
        ...ownerProps.general_gender,
        error: ownerProps.general_gender.error || ownerProps.centre_gender.error,
        loading: ownerProps.general_gender.loading || ownerProps.centre_gender.loading,
      }
    })
  ),
  renderWhileLoading(),
  renderForError(),
)
export default class Gender extends React.Component {
  render() {
    // use lodash group by centres
    let i = 0;
    const centres = _(this.props.centre_gender.genders_distributions)
      .groupBy('name')
      .map((objs, key) => ({
          'centre': key,
          'series': objs.map(
            data => ({name: data.gender, data: [data.count]}),
            index => i++,
          ),
        })
      )
      .value();

    // general, transform it into an nice, reverse in order to display it in the right order
    const seriesGeneral = this.props.data.generals_genders_distributions.map(
      data => ({name: data.gender, data: [data.count]})
    );

    return (
      <div>
        <Card>
          <CardHeader>Gender Distribution</CardHeader>
          <CardBody>
            <GenderChart data={this.props.data.generals_genders_distributions}
                         title="Gender Distribution of ESID"
                         categories={['Gender']}
                         series={seriesGeneral}/>
            <hr/>
            <br/>
            {/* for each centre */}
            {centres.map(
              centre => (
                <div key={'gender-' + centre.centre}>
                  <GenderChart data={this.props.data.generals_genders_distributions}
                               title={'Gender Distribution of ' + centre.centre}
                               categories={['Gender']}
                               series={centre.series}
                  />
                  <hr/>
                  <br/>
                </div>)
            )}
          </CardBody>

        </Card>
      </div>
    );
  }
};



// WEBPACK FOOTER //
// ./src/views/Statistics/Gender/Gender.js